export const menteeRoutes = [
  {
    path: "/mentees",
    name: "mentees",
    meta: { onlyAdmin: true },
    component: () => import(/* webpackChunkName: "groups" */ "./MenteeSearchView.vue"),
  },
];
